import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  ChangeDetectionStrategy,
  inject,
  DestroyRef,
  ChangeDetectorRef
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { ThemeService } from '../../../services/theme.service';
import { TABLE_CONFIGURATION } from '../../models/constants';
import { TableConfigurationDetail, TableConfigurationType, TableCssConfig } from '../../models/types';

@Component({
  selector: 'app-table-row-details',
  templateUrl: './table-row-details.component.html',
  styleUrl: './table-row-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableRowDetailsComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  private _cdr = inject(ChangeDetectorRef);
  private _themeService = inject(ThemeService);

  @Input() showDetails = false;
  @Input() entityType = '';
  @Input() serialNumber?: string;
  @Input() resolution?: string;
  @Input() description?: string;

  @Output() closeDetails = new EventEmitter<string>();

  tabs?: TableConfigurationDetail[] = [];
  selectedTab = 0;
  cssConfig!: TableCssConfig;
  hasClosingBtn = false;
  isLight = true;

  ngOnInit() {
    this.tabs = TABLE_CONFIGURATION[this.entityType as keyof TableConfigurationType].details;
    this.cssConfig = TABLE_CONFIGURATION[this.entityType as keyof TableConfigurationType].css;

    this.hasClosingBtn = ['machines'].includes(this.entityType);

    this._themeService.isLight$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap((x) => {
          this.isLight = x;
          this._cdr.markForCheck();
        })
      )
      .subscribe();
  }

  switchTab(index: number) {
    this.selectedTab = index;
    this._cdr.markForCheck();
  }

  onCloseDetails() {
    this.closeDetails.emit('');
    this._cdr.markForCheck();
  }
}
